import React, { useEffect } from "react";
import styles from "../WalletValueCard.module.scss";
import { ROUTES } from "../../../../../../routes";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const P2pTab = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );

  useEffect(() => {
    // If the current path is P2P and no specific route, redirect to BUY
    if (pathname === ROUTES.P2P || pathname === `${ROUTES.P2P}/`) {
      navigate(ROUTES.BUY);
    }
  }, [pathname, navigate]);

  const handleLinkClick = (route) => {
    if (kycStatus !== "APPROVED") {
      navigate(ROUTES.BUY); // Redirect to BUY if KYC is not approved
    } else {
      navigate(route); // Otherwise, go to the respective route
    }
  };

  return (
    <div className={styles.p2p_wrap}>
      <div className={`${styles.nav_bar} ${styles.buysell_tab}`}>
        <NavLink
          to={ROUTES.BUY}
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick(ROUTES.BUY);
          }}
        >
          BUY
        </NavLink>
        <NavLink
          to={ROUTES.SELL}
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick(ROUTES.SELL);
          }}
        >
          SELL
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
};

export default P2pTab;
